<div class="order-tiles">
  @for (order of orderList(); track order) {
    <div class="order-tile">
      <div class="meta-data container-fluid" tabindex="0" role="button"
           (click)="orderSelected(order)"
           (keydown.enter)="orderSelected(order)"
           (keydown.space)="$event.preventDefault(); orderSelected(order)">
        <div class="row">
          <div class="col-3">
            <div class="text-label">{{ 'case.dmsOrderType' | translate }}</div>
            <div class="value">
              @if (order.isDmsPreOrder) {
                {{ 'case.dmsOrderTypeAppointment' | translate }}
              } @else {
                {{ 'case.dmsOrderTypeOrder' | translate }}
              }
            </div>
          </div>
          <div class="col-3">
            <div class="text-label">{{ 'case.dmsOrderNumber' | translate }}</div>
            <div class="value bold" [title]="order.dmsId">
              {{ order.dmsId }}
            </div>
          </div>
          <div class="col-3">
            <div class="text-label">{{ 'case.dmsCustomerNumber' | translate }}</div>
            <div class="value" [title]="order.customer?.customerId?.dmsId">
              {{ order.customer?.customerId?.dmsId }}
            </div>
          </div>
          <div class="col-3">
            <div class="text-label">{{ 'case.modified' | translate }}</div>
            <div class="value" [title]="order.lastChangedDateTime | date:'short':'undefined':locale">
              {{ order.lastChangedDateTime | date:'short':'undefined':locale }}
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
